import React, {useState} from "react";
import styled from "@emotion/styled";
import {ValoresArr, CustomValue} from "./helper";
import {Whitecont, BtnLine, MainCheck} from "./styles";
import {Flex, colors} from "../../ui";
import {Mycheck} from "./../helpers";
import {config, useTransition} from "react-spring";
import {Btn} from "./../../UI-Components/Btn";



const Container = styled.div`
    position:relative;
`;

function FacturaComp({
                         position,
                         pagar,
                         clickCheck,
                         loadFunc,
                         clickCheckOtroValor,
                         onChangeOtroValor,
                         clickCheckValor,
                         showModal,
                         validator,
                         opcionesRecadudo,
                         valores,
                         numeroFacrtura,
                         item,
                         otherValue,
                         onChange,
                         checked,
                         value,
                         min,
                         max,
                         viewCheck = false,
                         modificarValor = false,
                         tipoModificacion,
                         checkOtroValor=false
                     }) {


    let codigofactura = null;
    codigofactura=numeroFacrtura.filter(i=> i.entidad === "facturaId");
    if(codigofactura.length>0)codigofactura=codigofactura[0].valor;
    else codigofactura=null;
    numeroFacrtura=codigofactura;

    const [state, setCV] = useState({
        customValue: checkOtroValor,
        valorActivo: null,
        cambioValorCount: 0
    })

    const Cambios = useTransition(state.customValue, null, {
        config: config.stiff,
        from: {transform: (state.customValue ? "translateY(100%)" : "translateY(-100%)"), opacity: 0,},
        enter: {transform: "translateY(0)", opacity: 1,},
        leave: {
            transform: (state.customValue ? "translateY(-100%)" : "translateY(100%)"),
            opacity: 0,
            position: "absolute",
            left: "0",
            bottom: 0
        }
    });
    
    if(state.cambioValorCount == 0 && state.customValue){
        setCV({...state, cambioValorCount: state.cambioValorCount+1})
        onChangeOtroValor(String(otherValue), position)
    }
    return (
        <Container className={"p-2"}>
            <Flex alg={"stretch"} className={"wc"}>
                <Whitecont
                    elastic={"1 0 80%"}
                    className={"p-2 p-md-1"}
                    alg={"stretch"}
                >
                    {viewCheck &&
                    <MainCheck elastic={"0 0 40px"} direction={"column"}>
                        {/* MAIN CHULO  =======  */}
                        <Mycheck
                            color="primary"
                            name={'MyRadio'}
                            clickCheck={onChange}
                            active={checked}
                            value={value}
                        />
                    </MainCheck>
                    }


                    <Flex elastic={"1 0 85%"} className={"pl-sm-2"}>

                        {/* NUMERO DE LA FACTURA ========== */}
                        <Flex jc={"flex-start"} className={"wc py-1 pl-2"}>
                            <i className="fa fa-info-circle  mr-2"
                               onClick={showModal}
                               style={{color: colors.btn, cursor: "pointer"}}
                            > </i>
                            {numeroFacrtura!==null?<small><b>NÚMERO DE FACTURA:</b> {numeroFacrtura}</small>:""}
                        </Flex>

                        {/* TRACIOCIONES OTRO VALOR TOGGLE  */}
                        <Flex elastic={"4 0 50%"} className={"position-relative"} alg={""}>
                            {
                                Cambios.map(({item, key, props}) => (
                                    !item ?
                                        <ValoresArr
                                            styles={props}
                                            key={key}
                                            change={clickCheckValor.bind(this)}
                                            currencySymbol={""}
                                            arr={valores}
                                        />
                                        : <CustomValue
                                            styles={props}
                                            key={key}
                                            position={position}
                                            value={otherValue}
                                            min={min}
                                            max={max}
                                            tipoModificacion={tipoModificacion}
                                            onChange={onChangeOtroValor.bind(this)}
                                        />
                                ))
                            }
                        </Flex>

                        {/* TOGGLE OTRO VALOR  ============ */}
                        {
                            modificarValor &&
                            <Flex elastic={"1 0 80px"} className={"px-1"}>
                                <BtnLine
                                    className={"wc"}
                                    type={"button"}
                                    brd={colors.btn}
                                    br={"8px"}
                                    onClick={() => {
                                        setCV({...state, customValue: !state.customValue, cambioValorCount: (!state.customValue ? state.cambioValorCount : 0)})
                                        // clickCheckOtroValor()
                                    }}
                                >
                                    {!state.customValue ? "Otro valor" : "Volver"}
                                </BtnLine>
                            </Flex>
                        }
                    </Flex>
                </Whitecont>
                <Flex
                    elastic={"1 0 80px"}
                    className={"px-0 px-sm-1 pt-1 pt-sm-0 position-relative"}
                    direction={"column"}
                    alg={"stretch"}
                >
                    <Btn
                        brdr={"10px"}
                        onClick={pagar}
                    >
                        PAGAR
                    </Btn>
                </Flex>
            </Flex>
        </Container>
    )
}

export default React.memo(FacturaComp);
